const state = {
  fieldsData: "",
  dateData: "",
  nonDateData: "",
  query: {
    dateMenu: "",
    from: "",
    to: "",
    operator: "",
    children: ""
  },
  sqlStatement: "",
  sqlQuery: {
    listSql: "",
    tableName: ""
  }
};

const mutations = {
  UPDATE_FIELDS_DATA(state, payload) {
    state.fieldsData = payload.map(payload => {
      return {
        text: payload.text,
        value: payload.value,
        type:
          payload.columnType !== undefined
            ? payload.columnType.toLowerCase()
            : "",
        editable: payload.editable,
        defaultSearch: payload.defaultSearch,
        colWidth: payload.colWidth
      };
    });
    state.dateData = payload.filter(
      payload =>
        payload.columnType === "DATE" || payload.columnType === "TIMESTAMP"
    );
    state.nonDateData = payload.filter(
      payload =>
        payload.columnType !== "DATE" && payload.columnType !== "TIMESTAMP"
    );
  },
  UPDATE_SQL_QUERY(state, payload) {
    state.sqlQuery = {
      listSql: payload.listSql,
      tableName: payload.tableName
    };
  },
  UPDATE_SQL_STATEMENT(state) {
    state.sqlStatement = objectToSQL(state.query);
  },
  UPDATE_QUERY(state, payload) {
    state.query = {
      dateMenu: payload.selectedDate,
      from: payload.from,
      to: payload.to,
      operator: payload.operator,
      children: payload.children
    };
    state.sqlStatement = objectToSQL(state.query);
  },
  RESET_QUERY_BUILDER() {
    state.fieldsData = "";
    state.dateData = "";
    state.nonDateData = "";
    state.query.dateMenu = "";
    state.query.from = "";
    state.query.to = "";
    state.query.operator = "";
    state.query.children = "";
    state.sqlStatement = "";
    state.sqlQuery.listSql = "";
    state.sqlQuery.tableName = "";
  }
};

const actions = {
  updateFieldsData(context, payload) {
    context.commit("UPDATE_FIELDS_DATA", payload);
  },
  updateQuery(context, payload) {
    context.commit("UPDATE_QUERY", payload);
  },
  updateSQLStatement(context) {
    context.commit("UPDATE_SQL_STATEMENT");
  },
  updateSqlQuery(context, payload) {
    context.commit("UPDATE_SQL_QUERY", payload);
  },
  resetQueryBuilder(context) {
    context.commit("RESET_QUERY_BUILDER");
  }
};

const getters = {
  getFieldsData: state => state.fieldsData,
  getDateData: state => state.dateData,
  getNonDateData: state => state.nonDateData,
  getQuery: state => state.query,
  getSQLStatement: state => state.sqlStatement,
  getSqlQuery: state => state.sqlQuery
};

export const queryBuilderModule = {
  namespace: true,
  state,
  mutations,
  actions,
  getters
};

function extractString(object) {
  let stringResult = "";
  if (object.children.length < 1) {
    stringResult = "";
  } else {
    for (let i = 0; i < object.children.length; i++) {
      let typeOfObject = object.children[i].type;
      let operatorOfObject = object.operator;
      if (typeOfObject === "rule") {
        let query = object.children[i].query;
        let begin = i === 0 ? " " : " " + operatorOfObject + " ";
        let end = i === object.children.length - 1 ? "" : " ";
        let isLike =
          query.operator === "LIKE" ? "%" : isNaN(query.value) ? "'" : "";
        let isLikeExtend = query.operator === "LIKE" ? "'" : "";
        stringResult +=
          begin +
          query.operand +
          " " +
          query.operator +
          " " +
          isLikeExtend +
          isLike +
          query.value +
          isLike +
          isLikeExtend +
          end;
      } else {
        let newObject = object.children[i].query;
        if (newObject.children.length < 1) {
          stringResult += " ";
        } else {
          let begin = i === 0 ? "" : " " + operatorOfObject + " ";
          stringResult += begin + " (" + extractString(newObject) + ") ";
        }
      }
    }
  }
  return stringResult;
}

function objectToSQL(object) {
  let isOneDate =
    object.from !== object.to
      ? " BETWEEN '" + object.from + "' AND '" + object.to + "'"
      : "='" + object.to + "'";
  let initString =
    object.dateMenu !== ""
      ? " AND (" + object.dateMenu + isOneDate + ") " + object.operator
      : " AND ";
  let resultString = initString + extractString(object);
  let errorString = ["AND", "AND ()"];
  for (let i = 0; i < errorString.length; i++) {
    if (resultString.endsWith(errorString[i])) {
      resultString = resultString.replace(/\sAND$/gm, "");
    }
  }
  if (resultString.toUpperCase() === "AND") {
    resultString = "";
  }
  return resultString;
}
